const RULES_URL = process.env.API_URL + '/rules/';

const getRules = (context, tags) => {
  return context.$http.get(RULES_URL, {params: {tags}});
};

const createRule = (context, rule) => {
  return context.$http.post(RULES_URL, rule);
};

const updateRule = (context, rule) => {
  return context.$http.put(RULES_URL, rule);
};

const deleteRule = (context, id) => {
  return context.$http.delete(RULES_URL, {params: {id: id}});
};

export default {
  getRules,
  createRule,
  updateRule,
  deleteRule
};



// WEBPACK FOOTER //
// ./src/api/rule/ruleHttp.js